import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "形番",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfKataban"
    label={label}
    size="small"
    inputProps={{ maxLength: 7 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;